import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import { Reveal, Pretitulo } from "@/components/Reveal";

export default function Sustentabilidad() {
  const { t } = useLang();
  const p = t.sustentabilidad;
  return (
    <div data-testid="pagina-sustentabilidad">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-sustentabilidad" />

      <section className="py-20 md:py-28" data-testid="su-intro">
        <div className="mx-auto max-w-3xl px-6 text-center md:px-10">
          <Reveal>
            <Pretitulo>{p.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-5xl">{p.titulo}</h2>
            <p className="mt-7 text-left text-[15.5px] leading-relaxed text-ink-soft md:text-center">{p.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28" data-testid="su-practicas">
        <div className="mx-auto max-w-[1100px] px-6 md:px-10">
          <div className="grid gap-x-16 md:grid-cols-2">
            {[0, 5].map((colBase) => (
              <div key={colBase}>
                {p.practicas.slice(colBase, colBase + 5).map((pr, i) => (
                  <Reveal key={pr.t} delay={i * 0.05} className="flex items-baseline gap-5 border-b border-lineas py-7" testid={`su-practica-${colBase + i + 1}`}>
                    <span className="font-serif text-2xl text-terra">{colBase + i + 1}.</span>
                    <div>
                      <h3 className="font-serif text-xl text-ink">{pr.t}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-ink-soft">{pr.d}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}